import React from 'react';
import { IHSANROLL_CASE_NOS } from '../../data/ihsanRollMock';
import { hasAttendance, tileStatus, whereabouts } from '../../lib/ihsanRollStore';
import { StatusDot } from './shared';

export default function HomeView({ store, onOpenCase, onWhereabouts }) {
  const board = whereabouts(store);
  return (
    <div className="px-4 pt-5 pb-8" data-testid="ihsanroll-home">
      <div className="flex items-start justify-between gap-3">
        <div>
          <h1 className="text-2xl font-extrabold text-[#0F172A]">Daily register</h1>
          <p className="text-sm text-muted-foreground mt-1">
            Tap a case number. Names stay off this screen.
          </p>
        </div>
        <button
          type="button"
          data-testid="ihsanroll-whereabouts"
          onClick={onWhereabouts}
          className="h-11 px-3 rounded-xl bg-primary text-white text-xs font-bold flex-shrink-0"
        >
          Whereabouts
        </button>
      </div>

      <p className="mt-3 text-xs font-semibold text-muted-foreground" aria-live="polite">
        In: {board.inCount} · Out: {board.out} · Overdue: {board.overdue}
      </p>

      <div className="mt-4 grid grid-cols-5 md:grid-cols-8 gap-2" data-testid="ihsanroll-case-grid">
        {IHSANROLL_CASE_NOS.map((no) => {
          const status = tileStatus(store, no);
          const logged = hasAttendance(store, no);
          return (
            <button
              key={no}
              type="button"
              data-testid={`ihsanroll-case-${no}`}
              onClick={() => onOpenCase(no)}
              className={`relative min-h-[56px] md:min-h-[64px] rounded-xl border bg-white flex flex-col items-center justify-center gap-1 active:scale-[0.97] ${
                status === 'overdue'
                  ? 'border-[#D64545]/40 bg-red-50'
                  : status === 'out'
                    ? 'border-amber-300 bg-amber-50'
                    : 'border-border'
              }`}
            >
              <span className="text-base md:text-lg font-extrabold text-[#0F172A] leading-none">{no}</span>
              <span className="flex items-center gap-1">
                <StatusDot status={status} />
                {logged && (
                  <span className="text-[9px] font-bold text-primary" aria-label="attendance logged">
                    ✓
                  </span>
                )}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
